import { ItemTypeMetadata } from "./item-type-metadata.enum"
import { BooleanItemMetadataBase } from "./item/boolean-item-metadata.model"
import { DataSourceItemMetadataBase } from "./item/datasource-item-metadata.model"
import { ItemMetadata, ItemMetadataBase } from "./item/item-metadata.model"
import { LengthItemMetadataBase } from "./item/length-item-metadata.model"
import { TimeItemMetadataBase } from "./item/time-item-metadata.model"
import { ValueItemMetadataBase } from "./item/value-item-metadata.model"
import { LayoutTypeMetadata } from "./layout-type-metadata.enum"
import { LayoutMetadata } from "./layout/layout-metadata.model"
import { RepeatLayoutMetadata, RepeatLayoutMetadataBase } from "./layout/repeat-layout-metadata.model"
import { RowLayoutMetadata, RowLayoutMetadataBase } from "./layout/row-layout.metadata.model"
import { SectionLayoutMetadata, SectionLayoutMetadataBase } from "./layout/section-layout.model"
import { TableLayoutMetadata, TableLayoutMetadataBase } from "./layout/table-layout-metadata.model"
import { WebServiceLayoutMetadata, WebServiceLayoutMetadataBase } from "./layout/webservice-layout-metadata.model"


export class MetadataFactory {

    static createLayoutFromType(type: LayoutTypeMetadata): LayoutMetadata {
        switch (type) {
            case LayoutTypeMetadata.Section:
                return MetadataFactory.createSectionLayout()
            case LayoutTypeMetadata.Repeat:
                return MetadataFactory.createRepeatLayout()
            case LayoutTypeMetadata.Table:
                return MetadataFactory.createTableLayout()
            case LayoutTypeMetadata.Row:
                return MetadataFactory.createRowLayout()
            case LayoutTypeMetadata.WebService:
                return MetadataFactory.createWebServiceLayout()
        }
    }

    static createSectionLayout(): SectionLayoutMetadata {
        return new SectionLayoutMetadataBase(LayoutTypeMetadata.Section)
    }

    static createRepeatLayout(): RepeatLayoutMetadata {
        return new RepeatLayoutMetadataBase(LayoutTypeMetadata.Repeat)
    }

    static createTableLayout(): TableLayoutMetadata {
        return new TableLayoutMetadataBase(LayoutTypeMetadata.Table)
    }

    static createRowLayout(): RowLayoutMetadata {
        return new RowLayoutMetadataBase(LayoutTypeMetadata.Row)
    }

    static createWebServiceLayout(): WebServiceLayoutMetadata {
        return new WebServiceLayoutMetadataBase(LayoutTypeMetadata.WebService)
    }

    static createItem(itemType: ItemTypeMetadata): ItemMetadata {
        switch (itemType) {
            case ItemTypeMetadata.Button:
                return new ItemMetadataBase(itemType)
            case ItemTypeMetadata.Text:
                return new LengthItemMetadataBase(itemType)
            case ItemTypeMetadata.Numeric:
                return new ItemMetadataBase(itemType)
            case ItemTypeMetadata.CheckBox:
                return new BooleanItemMetadataBase(itemType)
            case ItemTypeMetadata.Custom:
                return new ItemMetadataBase(itemType)
            case ItemTypeMetadata.Datepicker:
                return new ItemMetadataBase(itemType)
            case ItemTypeMetadata.Html:
                return new ValueItemMetadataBase(itemType)
            case ItemTypeMetadata.Time:
                return new TimeItemMetadataBase(itemType)
            case ItemTypeMetadata.Radio:
                return new DataSourceItemMetadataBase(itemType)
            case ItemTypeMetadata.Select:
                return new DataSourceItemMetadataBase(itemType)
            case ItemTypeMetadata.MultiCheckBox:
                return new DataSourceItemMetadataBase(itemType)
            case ItemTypeMetadata.TextArea:
                return new LengthItemMetadataBase(itemType)
        }
    }

}